import script from "./ClassroomSales.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomSales.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomSales.vue?vue&type=style&index=0&id=0741d041&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0741d041"]])

export default __exports__